import React from "react";
import { Tag } from "antd";
import { useHistory } from "react-router-dom";
import "./FacturaCell.scss";

const FacturaCell = ({ factura, isAdmin = false }) => {
  const history = useHistory();

  const getStatusColor = (status) => {
    switch (status) {
      case "paid":
        return "green";
      case "partial":
        return "gold";
      case "unpaid":
        return "default";
      case "overdue":
        return "red";
      default:
        return "default";
    }
  };

  const formatFacturaId = (facturaId) => {
    if (!facturaId) return "";
    // Split after date and dash, but before short client id and increment
    // e.g. "2025-09-03-abcd1234-01" becomes "2025-09-03-\nabcd1234-01"
    const match = facturaId.match(/^(\d{4}-\d{2}-\d{2}-)(.*)/);
    if (match) {
      return (
        <div className="factura-id">
          <div>{match[1]}</div>
          <div>{match[2]}</div>
        </div>
      );
    }
    return <div className="factura-id">{facturaId}</div>;
  };

  const handleFacturaClick = (e) => {
    e.stopPropagation();
    if (factura?.id) {
      const facturaPath = isAdmin
        ? `/admin/facturas/edit/${factura.id}`
        : `/billing/facturas/${factura.id}`;
      history.push(facturaPath);
    }
  };

  const hasFactura = factura?.id;

  if (!hasFactura) {
    return (
      <div className="factura-cell unassigned">
        <div className="factura-text">Unassigned</div>
      </div>
    );
  }

  return (
    <div className="factura-cell assigned" onClick={handleFacturaClick}>
      {formatFacturaId(factura.facturaId)}
      <Tag color={getStatusColor(factura.status)} className="factura-status-tag">
        {factura.status}
      </Tag>
    </div>
  );
};

export default FacturaCell;
